import { BasicoApi } from '@common/api';
const KanbanTipoInstrumentoService = {
  listar: function (resource) {
    return BasicoApi.get()(`/KanbanProgramacaoManual/disponibilidade`, resource);
  },
};

export default KanbanTipoInstrumentoService;
